module.exports = __webpack_public_path__ + "img/quan-item-1.c7474a29.png";